if (!customElements.get('price-slider')) {
  class PriceSlider extends HTMLElement {
    constructor() {
      super();
      this.firstRun = true;
      this.updateTimeout = null;
      this.previousMinValue = null;
      this.previousMaxValue = null;
      this.init();
    }

    init() {
      this.priceSlider = this.querySelector('#price-slider');

      this.priceRangeComponent = this.parentElement?.querySelector('price-range');
      if (!this.priceRangeComponent) {
        console.error("Price range component not found");
        return;
      }

      this.minInput = this.priceRangeComponent.querySelector('[name="filter.v.price.gte"]');
      this.maxInput = this.priceRangeComponent.querySelector('[name="filter.v.price.lte"]');

      if (!this.minInput || !this.maxInput) {
        console.error("Min or Max input elements not found");
        return;
      }

      this.previousMinValue = this.minInput.value;
      this.previousMaxValue = this.maxInput.value;

      this.initSlider();
    }

    initSlider() {  
  if (this.priceSlider.noUiSlider) {  
    this.priceSlider.noUiSlider.destroy();  
  }  

  const currentMinValue = Number(this.minInput.value) || 0;  
  const currentMaxValue = Number(this.maxInput.value) || 1000;  
  this.minValue = Number(this.minInput.dataset.min) || 0;  
  this.maxValue = Number(this.maxInput.dataset.max) || 1000;  

  noUiSlider.create(this.priceSlider, {  
    start: [currentMinValue, currentMaxValue],  
    connect: true,  
    range: {  
      'min': this.minValue,  
      'max': this.maxValue,  
    },  
    step: 1,  
    tooltips: false,  
  });  

  // Create labels for min and max values  
  const minValueLabel = document.createElement('div');  
  const maxValueLabel = document.createElement('div');  
  minValueLabel.className = 'slider-label min-label';  
  maxValueLabel.className = 'slider-label max-label';  
  this.priceSlider.appendChild(minValueLabel);  
  this.priceSlider.appendChild(maxValueLabel);  

  this.priceSlider.noUiSlider.on('update', (values) => {  
    if (this.firstRun) {  
      this.firstRun = false;  
      return;  
    }  

    clearTimeout(this.updateTimeout);  
    this.updateTimeout = setTimeout(() => {  
      const formattedMinInput = parseFloat(this.minInput.value.replace(/,/g, '')) || this.minValue;  
      const formattedMaxInput = parseFloat(this.maxInput.value.replace(/,/g, '')) || this.maxValue;  
      const formattedValuesMin = parseFloat(values[0].replace(/,/g, ''));  
      const formattedValuesMax = parseFloat(values[1].replace(/,/g, ''));  

      if (formattedMinInput !== formattedValuesMin || formattedMaxInput !== formattedValuesMax) {  
        const newMinValue = values[0];  
        const newMaxValue = values[1];  
        let changedInput = null;  

        if (newMinValue !== this.previousMinValue) {  
          changedInput = this.minInput;  
          this.previousMinValue = newMinValue;  
        } else if (newMaxValue !== this.previousMaxValue) {  
          changedInput = this.maxInput;  
          this.previousMaxValue = newMaxValue;  
        }  

        this.minInput.value = newMinValue;  
        this.maxInput.value = newMaxValue;  

        if (changedInput) {  
          const form = changedInput.closest('form');  
          const formData = new FormData(form);  
          new URLSearchParams(formData).toString();  
          this.FiltersPram = new URLSearchParams(formData).toString();  
          this.toggleLoading();  
          this.updateUrl();  
        }  
      }  

      // Update labels with current values  
      minValueLabel.innerText = `${window.accessibilityStrings.currency}${Math.round(formattedValuesMin)}`;  
      maxValueLabel.innerText = `${window.accessibilityStrings.currency}${Math.round(formattedValuesMax)}`;  
    }, 500);  
  });  
}


    toggleLoading() {
      const countContainer = document.getElementById('ProductCount');
      const countContainerDesktop = document.getElementById('ProductCountDesktop');
      const loadingSpinners = document.querySelectorAll(
        '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
      );
      loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
      document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
      if (countContainer) {
        countContainer.classList.add('loading');
      }
      if (countContainerDesktop) {
        countContainerDesktop.classList.add('loading');
      }


      // 
      const drawerEl = document.querySelector('.mobile-facets__disclosure');
      console.log(drawerEl);
      if (drawerEl && drawerEl.classList.contains('menu-opening')) {
        drawerEl.classList.remove('menu-opening');
        setTimeout(() => {
          drawerEl.removeAttribute('open');
        }, 300);
      }
    }

    updateUrl() {
      const collectionHandle = window.location.pathname.split('/').pop();
      let updatedUrl = `${collectionHandle}?${this.FiltersPram}`;
      console.log(updatedUrl, 'UPDATED URL');
      window.history.replaceState({}, '', updatedUrl);
      this.fetchProducts();
    }
    async fetchProducts() {
      const apiUrl = `${this.dataset.url}&${this.FiltersPram}`;
      console.log(apiUrl);
      try {
        const response = await fetch(apiUrl);
        const text = await response.json();
        const firstKey = Object.keys(text)[0];
        const htmlString = text[firstKey];
        const parser = new DOMParser();
        const textDoc = parser.parseFromString(htmlString, 'text/html');
        console.log(textDoc);

        this.sectionIdSectionSource = textDoc?.querySelector(`#shopify-section-${this.dataset.section}`);
        this.sectionIdSection = document.querySelector(`#shopify-section-${this.dataset.section}`);
        setTimeout(() => {
          this.sectionIdSection.outerHTML = this.sectionIdSectionSource.outerHTML;
        }, 100);
      }
      catch (error) {
        console.error('Error fetching products:', error);
        alert('There was an error fetching products. Please try again.');
        location.reload();
      }
    }
  }
  customElements.define('price-slider', PriceSlider);
}
